﻿function onRegisterButtonClick(e) {
    checkPhoneRequirement();
    const form = $("[data-registration-form]");
    if (!form.valid())
        return;
    e.preventDefault();
    const $button = form.find('button[type="submit"], input[type="submit"]');
    const partnerByPhone = $('#PartnerByPhone').is(':checked');
    const bauerByPhone = $('#BauerByPhone').is(':checked');
    const phoneNumber = $("#PhoneNumber").val();
    if (partnerByPhone === true || bauerByPhone === false) {
        if (phoneNumber !== '') {
            $button.attr('disabled', 'disabled');
            $(form).submit();
        } else {
            $("[data-phone-validation]").removeClass("hidden");
        }
    } else {
        $button.attr('disabled', 'disabled');
        $(form).submit();
    }
}

function getTopHeaderHeight() {
    let height = 0;
    if (window.isViewportGreaterThanOrEqualTo('lg')) {
        const siteSelector = $(".site-selector");
        height += siteSelector.height();
        siteSelector.removeClass("collapse");
        siteSelector.removeAttr("style");
    } else if (window.isViewportLessThan('md')) {
        const mobileFixedHeader = $("#fixedHeader");
        height += mobileFixedHeader.height();
    } else if (window.getViewportSize()=='md') {
        const tabletFixedHeader = $("#fixedHeader");
        height += tabletFixedHeader.height();
    }
    return height;
}

const sph = 'scrolled-past-header';

function onFNScroll() {
    const scrollPosition = window.pageYOffset;
    //var headerHeight = $('#fixedHeader').height();
    const headerHeight = getTopHeaderHeight();
    if (scrollPosition > headerHeight) {
        $('html').addClass(sph);
    } else {
        $('html').removeClass(sph);
    }
    //if (isTablet || isMobile) {
    //    if (!$(".leaderboard-container").hasClass('ad-scroll-fix')) {
    //        $(".leaderboard-container").addClass('ad-scroll-fix');
    //    }
    //} else {
    //    if ($(".leaderboard-container").hasClass('ad-scroll-fix')) {
    //        $(".leaderboard-container").removeClass('ad-scroll-fix');
    //    }
    //}
}

function fixLeaderboardOnMobileTablet() {
    const width = $(document).width();
    const isTablet = width <= 976 && width > 768;
    const isMobile = width <= 768;
    const newTakeOverActive = $('body').hasClass('hero-takeover-active');
    //if (newTakeOverActive) {
    //    $(".leaderboard-container").removeClass('ad-scroll-fix');
    //    return;
    //}
    //if (isTablet || isMobile) {
    //    if (!$(".leaderboard-container").hasClass('ad-scroll-fix')) {
    //        $(".leaderboard-container").addClass('ad-scroll-fix');
    //    }
    //} else {
    //    if ($(".leaderboard-container").hasClass('ad-scroll-fix')) {
    //        $(".leaderboard-container").removeClass('ad-scroll-fix');
    //    }
    //}
}

function checkPhoneRequirement() {
    const partnerByPhone = $('#PartnerByPhone').is(':checked');
    const bauerByPhone = $('#BauerByPhone').is(':checked');
    const phoneNumber = $("#PhoneNumber").val();
    if (partnerByPhone === true || bauerByPhone === false) {
        if (phoneNumber !== '') {
            $("[data-phone-validation]").addClass("hidden");
        } else {
            $("[data-phone-validation]").removeClass("hidden");
        }
    } else {
        $("[data-phone-validation]").addClass("hidden");
    }
}

function onShowNavbar(e) {
    let minusHeight = 85;
    if ($('html').hasClass('scrolled-past-header')) {
        minusHeight = 35;
        if ($('body').hasClass('mrcms-admin-bar-on')) {
            minusHeight = 65;
        }
    } else {
        if ($('body').hasClass('mrcms-admin-bar-on')) {
            minusHeight = 115;
        }
    }

    const windowHeight = $(window).innerHeight() - minusHeight;
    $(".navbar-collapse .nav.navbar-nav ").css({height: windowHeight});
    $("body").attr("style", "margin: 0; height: 0; overflow: hidden;");
    $("#main-content").attr("style", "visibility:hidden");
    //$(".ad-scroll-fix").hide();
}

function onHideNavbar(e) {
    $("body").attr("style", "");
    $("#main-content").attr("style", "");
    //$(".ad-scroll-fix").show();
}

function onShowRightHandBar(e) {
    if (window.isViewportLessThan('lg')) {
        $("body").attr("style", "margin: 0; height: 0; overflow: hidden;");
        $("[data-ads-main-column]").attr("style", "margin: 0; height: 0; overflow: hidden;visibility:hidden");
        $(".leaderboard-container").attr("style", "height: 0; visibility:hidden");
        $("footer").attr("style", "height: 0; visibility:hidden");
        //$(".ad-scroll-fix").hide();
    }
}

function onShownRightHandBar(e) {
    if (window.isViewportLessThan('lg')) {
        let minusHeight = 90;
        if ($('html').hasClass('scrolled-past-header')) {
            minusHeight = 30;
        }
        const rightMenuHeight = $(window).innerHeight() - minusHeight;
        $("#righthandbar.collapse.in").css({height: rightMenuHeight});
    }
}

function onHideRightHandBar(e) {
    if (window.isViewportLessThan('lg')) {
        $("body").attr("style", "");
        $("[data-ads-main-column]").attr("style", "");
        $(".leaderboard-container").attr("style", "");
        $("footer").attr("style", "");
        //$(".ad-scroll-fix").show();
    }
}

function onShowHidePasswordClick(event) {
    event.preventDefault();
    const input = $('#show_hide_password input');
    const visible = $('#show_hide_password i');
    if (input.attr("type") === "text") {
        input.attr('type', 'password');
        visible.addClass("fa-eye-slash");
        visible.removeClass("fa-eye");
    } else if (input.attr("type") === "password") {
        input.attr('type', 'text');
        visible.removeClass("fa-eye-slash");
        visible.addClass("fa-eye");
    }
}

function fixAdOnScroll() {
    var width = $(document).width();
    var isTablet = width <= 976 && width > 768;
    var isMobile = width <= 768;
    if (isTablet || isMobile) {
        if ($(window).scrollTop() > 100) {
            if (!$("#top-leaderboard").hasClass('ad-scroll-fix')) {
                $("#top-leaderboard").addClass('ad-scroll-fix');
            }
        } else {
            $("#top-leaderboard").removeClass('ad-scroll-fix');
        }
    }
}

function stickyInline01() {
    var width = $(document).width();
    var isTablet = width <= 976 && width > 768;
    var isMobile = width <= 768;
    if (isTablet || isMobile) {
        $("#top-leaderboard").removeClass('sticky-dfp-ad');
    }
}

function handleBodyCopyToggle() {
    var textDiv = document.getElementById("text");
    var toggleBtn = document.getElementById("body-copy-toggle");
    if (textDiv && toggleBtn) {
        // Get the height of the 'textDiv' in pixels
        var textDivHeight = textDiv.scrollHeight; // use scrollHeight to get total content height

        // If 'textDiv' height is more than the height of 2 lines of text, show the toggle button
        if (textDivHeight > 50) {
            toggleBtn.style.display = "block";
            // Set initial collapsed state
            textDiv.style.maxHeight = "3.2em";

            toggleBtn.addEventListener("click", function (e) {
                e.preventDefault();
                var isCollapsed = textDiv.style.maxHeight === "3.2em";
                if (isCollapsed) {
                    textDiv.style.maxHeight = textDiv.scrollHeight + "px"; // Expand it to its full height
                    this.innerHTML = "Show less";
                } else {
                    textDiv.style.maxHeight = "3.2em"; // Collapse it
                    this.innerHTML = "Show more +";
                }
            });
        }
    }
}
export function setupMain() {
    stickyInline01();
    // need to do this after document.ready so that all dependencies are loaded
    //$(window).scroll(fixingHeaderBar);
    //$(window).on('load', fixingHeaderBar);
    //$(window).on('resize', fixingHeaderBar);
    $(document).on("click", "#OtherButton", function () {
        const classAttribute = $(this).attr("class");
        if (classAttribute.indexOf("active") > -1) {
            $('[data-other-text]').show();
        } else {
            $('[data-other-text]').hide();
            $('#OtherText').val('');
        }
    });
    fixLeaderboardOnMobileTablet();
    $(window).resize(function () {
        fixLeaderboardOnMobileTablet();
    });
    $('nav.navbar .collapse').on('show.bs.collapse', onShowNavbar);


    $('nav.navbar .collapse').on('hide.bs.collapse', onHideNavbar);


    $('#righthandbar').on('show.bs.collapse', onShowRightHandBar);


    $('#righthandbar').on('shown.bs.collapse', onShownRightHandBar);


    $('#righthandbar').on('hide.bs.collapse', onHideRightHandBar);

    $("#compareanothercar-link").click(function (event) {
        event.preventDefault();
        $("html, body").animate({scrollTop: $($(this).attr("href")).offset().top}, 500);
    });
    $("#show_hide_password a").on('click', onShowHidePasswordClick);

    $("[data-past-events]").click(function () {
        $('html, body').animate({
            scrollTop: $("#past-events").offset().top
        }, 100);
    });
    $("#PartnerByPhone").change(function () {
        checkPhoneRequirement();
    });
    $("#BauerByPhone").change(function () {
        checkPhoneRequirement();
    });
    $("#PhoneNumber").blur(function () {
        checkPhoneRequirement();
    });
    $("#PhoneNumber").keypress(function () {
        $("[data-phone-validation]").addClass("hidden");
    });
    $(document).on("click", "[data-btn-register]", onRegisterButtonClick);


    window.setTimeout(function () {
        $(".form-submitted-message").fadeTo(500, 0).slideUp(500, function () {
            $(this).remove();
        });
    }, 4000);

    $(window).on('scroll', onFNScroll);


    /*$('body').prepend('<a href="#" class="back-to-top">Back to Top</a>');*/
    const amountScrolled = 300;
    $(window).scroll(function () {
        if ($(window).scrollTop() > amountScrolled) {
            $('a.back-to-top').fadeIn('slow');
        } else {
            $('a.back-to-top').fadeOut('slow');
        }
    });
    $('a.back-to-top, a.simple-back-to-top').click(function () {
        $('html, body').animate({ 
            scrollTop: 0
        }, 700);
        return false;
});
    $('[data-extra-content]').click(function (e) {
        e.preventDefault();
        $('#extra-content').toggle("slow");
    });
    $('[data-more-charging-info]').click(function () {
        $('html, body').animate({
            scrollTop: $("#charging-data").offset().top - 100
        }, 700);
        return false;
    });
    $(document).on("scroll", fixAdOnScroll);

    handleBodyCopyToggle();
    // $('ul.dropdown-menu [data-toggle=dropdown]').on('click', function (event) {
    //     // Avoid following the href location when clicking
    //     event.preventDefault();
    //     // Avoid having the menu to close when clicking
    //     event.stopPropagation();
    //     // If a menu is already open we close it
    //     //$('ul.dropdown-menu [data-toggle=dropdown]').parent().removeClass('open');
    //     // opening the one you clicked on
    //     //$(this).parent().addClass('open');
    //
    //     $(this).closest(".dropdown-submenu").toggleClass("open");
    // });
}